module.exports = __webpack_public_path__ + "ffd5b35d89c7dd7be062620557e43958.pdf";